<template>
  <modal
    name="modal--delete-waste"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="300"
    :height="'auto'"
    @before-open="beforeOpen"
    @before-close="beforeClose"
  >
    <div
      class="flex flex-col text-black h-full bg-white overflow-hidden w-full justify-between p-4"
    >
      <div class="w-full">
        <div class="text-center text-4xl mb-1 font-extralight tracking-tight">
          Delete Log
        </div>
        <div class="text-center text-2xl mb-6 font-extralight tracking-tight">
          Are you sure?
        </div>

        <div class="flex flex-row justify-between mt-3">
          <button
            class="buttonOutline focus:shadow-outline focus:outline-none"
            @click="hideModal"
          >
            Cancel
          </button>
          <button
            class="ml-3 button focus:shadow-outline focus:outline-none bg-red-500 hover:bg-red-600 text-white"
            @click="confirm"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ModalDeleteWaste',
  data() {
    return {
      wasteId: null
    }
  },
  methods: {
    ...mapActions('config', ['setFabVisible']),
    ...mapActions('storeModule/waste', ['deleteWaste']),

    beforeOpen(event) {
      if (event.params && event.params.wasteId) {
        this.wasteId = event.params.wasteId
      }
      this.setFabVisible(false)
    },

    beforeClose() {
      this.wasteId = null
      this.setFabVisible(true)
    },

    hideModal() {
      this.$modal.hide('modal--delete-waste')
    },

    confirm() {
      this.deleteWaste({ id: this.wasteId })
        .catch((error) => {
          console.error('Error deleting waste:', error)
        })
        .finally(() => {
          this.hideModal()
        })
    }
  }
}
</script>
